import React from 'react';

class Matrix extends React.Component {
  constructor(props) {
    super(props);

    this.setup = this.setup.bind(this);
  }

  setup() {
    var that = this;

    var canvas = this.canvas;

    canvas.width = that.props.w ? that.props.w : 600;
    canvas.height = that.props.w ? that.props.w : 600;

    var ctx = canvas.getContext('2d');

    var letters = ['0', '1'];

    var fontSize = this.props.fontSize || 14,
      columns = canvas.width / fontSize;

    var drops = [];
    for (var i = 0; i < columns; i++) {
      drops[i] = 1;
    }

    setInterval(function () {
      ctx.fillStyle = that.props.background;

      ctx.fillRect(0, 0, canvas.width, canvas.height);

      for (var i = 0; i < drops.length; i++) {
        var text = letters[Math.floor(Math.random() * letters.length)];

        ctx.fillStyle = '#fff';

        ctx.font = fontSize + 'px Montserrat';

        ctx.fillText(text, i * fontSize, drops[i] * fontSize);

        drops[i]++;

        if (drops[i] * fontSize > canvas.height && Math.random() > 0.95) {
          drops[i] = 0;
        }
      }
    }, 50);
  }

  render() {
    return <canvas id={this.props.id}></canvas>;
  }
  componentDidMount() {
    this.canvas = document.getElementById(this.props.id);

    this.setup();
  }
}

export default Matrix;
